import { Clock, HelpCircle, Tag, Warehouse } from 'lucide-react'

import type { FreshnessVm } from '../model/types'
import type { ProductFactsVm } from '../model/productFacts'
import { QueryState } from './QueryState'

/** Не актуально — словом и значком рядом с заголовком; актуальное не подписывается, чтобы не шуметь. */
function Staleness({ freshness }: { freshness: FreshnessVm | null }) {
  if (freshness === null || freshness.kind === 'fresh') return null
  return (
    <span className="onec-facts__stale" role="status" title={freshness.detail ?? undefined}>
      {freshness.kind === 'stale' ? <Clock size={14} aria-hidden="true" /> : <HelpCircle size={14} aria-hidden="true" />}
      {freshness.label}
    </span>
  )
}

/**
 * Цены и остатки в карточке товара — только чтение (решение владельца 22.10.2026): цена по видам, остаток всего и по
 * складам. Записи закупок здесь нет и не будет: закупки идут через поставки. На телефоне блоки друг под другом, на
 * компьютере — рядом.
 */
export function ProductFacts({ vm, onRetry }: { vm: ProductFactsVm; onRetry: () => void }) {
  return (
    <section className="onec-section onec-facts" aria-label="Цены и остатки">
      <div className="onec-facts__group">
        <h3 className="onec-facts__title">
          <Tag size={16} aria-hidden="true" /> Цены <Staleness freshness={vm.prices.freshness} />
        </h3>
        <QueryState query={vm.prices.query} emptyText="Цен в 1С нет" onRetry={onRetry} />
        {vm.prices.rows.length > 0 && (
          <dl className="onec-facts__list" aria-label="Цены по видам">
            {vm.prices.rows.map((row) => (
              <div key={row.key} className="onec-facts__row">
                <dt>{row.label}</dt>
                <dd className="onec-facts__money">{row.priceText}</dd>
              </div>
            ))}
          </dl>
        )}
      </div>

      <div className="onec-facts__group">
        <h3 className="onec-facts__title">
          <Warehouse size={16} aria-hidden="true" /> Остатки
          {vm.stock.totalText !== null && <span className="onec-facts__total">всего {vm.stock.totalText}</span>}
          <Staleness freshness={vm.stock.freshness} />
        </h3>
        <QueryState query={vm.stock.query} emptyText="Остатков нет" onRetry={onRetry} />
        {vm.stock.rows.length > 0 && (
          <dl className="onec-facts__list" aria-label="Остатки по складам">
            {vm.stock.rows.map((row) => (
              <div key={row.warehouse} className="onec-facts__row">
                <dt>{row.warehouse}</dt>
                <dd>{row.quantityText}</dd>
              </div>
            ))}
          </dl>
        )}
      </div>
    </section>
  )
}
